/**
 * @generated SignedSource<<d165f7b52ac1d27b2e08bf6864c1219f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CashbackQuery$variables = {
  requiredTags?: ReadonlyArray<string> | null;
  promoTags?: ReadonlyArray<string> | null;
};
export type CashbackQuery$data = {
  readonly cashbacks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly tags: ReadonlyArray<string>;
      };
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"Offers_offers">;
  } | null;
  readonly cashbackPromos: {
    readonly " $fragmentSpreads": FragmentRefs<"OfferPromoBanner_promos">;
  } | null;
};
export type CashbackQuery = {
  variables: CashbackQuery$variables;
  response: CashbackQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "promoTags"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requiredTags"
},
v2 = {
  "kind": "Literal",
  "name": "rejectedTags",
  "value": [
    "gaming"
  ]
},
v3 = [
  {
    "fields": [
      (v2/*: any*/),
      {
        "kind": "Variable",
        "name": "requiredTags",
        "variableName": "requiredTags"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "fields": [
      (v2/*: any*/),
      {
        "kind": "Variable",
        "name": "requiredTags",
        "variableName": "promoTags"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paysReward",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardLabel",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CashbackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "cashbacks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Offers_offers"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "cashbackPromos",
        "args": (v6/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "cashbacks",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OfferPromoBanner_promos"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CashbackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "cashbacks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Advertiser",
                    "kind": "LinkedField",
                    "name": "advertiser",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "categories",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tag",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "cashbackPromos",
        "args": (v6/*: any*/),
        "concreteType": "OfferConnection",
        "kind": "LinkedField",
        "name": "cashbacks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "desktopImageUrl",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Advertiser",
                    "kind": "LinkedField",
                    "name": "advertiser",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a1f34ce2225a2d448ba9f1c85ab6973f",
    "id": null,
    "metadata": {},
    "name": "CashbackQuery",
    "operationKind": "query",
    "text": "query CashbackQuery(\n  $requiredTags: [String!]\n  $promoTags: [String!]\n) {\n  cashbacks(input: {requiredTags: $requiredTags, rejectedTags: [\"gaming\"]}) {\n    edges {\n      node {\n        id\n        tags\n      }\n    }\n    ...Offers_offers\n    id\n  }\n  cashbackPromos: cashbacks(input: {requiredTags: $promoTags, rejectedTags: [\"gaming\"]}, first: 1) {\n    ...OfferPromoBanner_promos\n    id\n  }\n}\n\nfragment OfferItem_offer on Offer {\n  id\n  title\n  guid\n  advertiser {\n    name\n    imageUrl\n  }\n  tags\n  paysReward\n  rewardLabel\n}\n\nfragment OfferPromoBanner_promos on OfferConnection {\n  edges {\n    node {\n      paysReward\n      id\n      imageUrl\n      desktopImageUrl\n      title\n      rewardLabel\n      slug\n      guid\n      advertiser {\n        name\n      }\n    }\n  }\n}\n\nfragment Offers_offers on OfferConnection {\n  edges {\n    node {\n      id\n      title\n      advertiser {\n        name\n      }\n      categories {\n        tag\n        name\n      }\n      tags\n      ...OfferItem_offer\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "936f5bd29efab1644517c2950bc87536";

export default node;
